import React, {
    Fragment,
    useState,
    useEffect,
    useContext,
    createRef,
} from "react";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { ContainerContext } from "context/Container";
import { useAuth } from "hooks/Auth";
import DropdownMenu from "components/Menus/DropdownMenu";
import { useFormikContext } from "formik";
import { fromString, fromNow } from "helpers/Date";
import { modal } from "components/HeadlessModal";
import PrimaryButton from "components/Buttons/PrimaryButton";

function PublishButton(props) {
    const { state } = useContext(ContainerContext);
    const auth = useAuth();

    const [isPublished, setIsPublished] = useState(false);
    const { setFieldValue, submitForm } = useFormikContext();
    const dateTimeRef = createRef();

    const publishNow = () => {
        if (!state.isUserEditable || !auth.user.can("container", "publish")) {
            return;
        }

        setFieldValue(
            "published_at",
            fromNow().toUTC().toFormat("yyyy-MM-dd HH:mm:ss")
        );
        setTimeout(() => {
            submitForm();
        });
    };
    const publishLater = () => {
        modal({
            title: "Schedule Publishing",
            confirmText: "Schedule It",
            children: (
                <Fragment>
                    <div className="mb-2">
                        You can set a publication date and time in the future or
                        past. Please be aware that this will impact the final
                        URL of the article.
                    </div>
                    <div>
                        <input
                            type="datetime-local"
                            className="block w-full rounded-md border-gray-300 py-2 px-4 shadow-sm focus:border-green-500 focus:ring-green-500 disabled:bg-white sm:text-sm"
                            ref={dateTimeRef}
                            defaultValue={fromNow()
                                .plus({ days: 1 })
                                .toFormat("yyyy-MM-dd'T00:00:00'")}
                        />
                    </div>
                </Fragment>
            ),
            buttons: () => (
                <Fragment>
                    <PrimaryButton
                        onClick={() => {
                            setFieldValue(
                                "published_at",
                                fromString(dateTimeRef.current.value)
                                    .toUTC()
                                    .toFormat("yyyy-MM-dd HH:mm:ss")
                            );
                            setTimeout(() => {
                                submitForm();
                                modal.dismiss();
                            });
                        }}
                    >
                        Schedule It
                    </PrimaryButton>
                    <SecondaryButton onClick={modal.dismiss}>
                        Cancel
                    </SecondaryButton>
                </Fragment>
            ),
        });
    };

    const unPublish = () => {
        if (!state.isUserEditable || !auth.user.can("container", "publish")) {
            return;
        }

        setFieldValue("published_at", null);
        setTimeout(() => {
            submitForm();
        });
    };

    useEffect(() => {
        if (!state.container.uuid) {
            setIsPublished(false);
        } else {
            setIsPublished(state.container.published_at ? true : false);
        }
    }, [state.container, auth.user]);

    if (state.loading) {
        return (
            <div>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    if (!state.container.uuid) {
        return (
            <SecondaryButton
                label="Publish"
                className="w-full"
                disabled={true}
            />
        );
    } else if (isPublished) {
        return (
            <SecondaryButton
                label="Unpublish"
                disabled={!state.isUserEditable}
                className="w-full"
                onClick={unPublish}
            />
        );
    } else {
        return (
            <DropdownMenu
                label="Publish"
                variant="primary"
                disabled={!state.isUserEditable}
                menuItems={[
                    <button
                        type="button"
                        onClick={publishNow}
                        className="w-full text-left"
                    >
                        Publish Now
                    </button>,
                    <button
                        type="button"
                        onClick={publishLater}
                        className="w-full text-left"
                    >
                        Schedule Publishing
                    </button>,
                ]}
            />
        );
    }
}

export default PublishButton;
